<i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()" (click)="dismiss()"  aria-hidden="true"></i>
<div ngbAutofocus class="d-flex flex-column justify-content-center align-items-center px-4 pt-5">
    <div class="my-4 px-0 px-md-2 text-sm-left text-md-center">
        <h3>{{ data?.title }}</h3>
        <p *ngIf="data.message" class="message" [innerHTML]="data.message"></p>
    </div>
    <div class="d-flex justify-content-between direction mb-5">
        <button class="btn edp-btn-secondary mt-3 d-none"></button>
        <button class="btn edp-btn-secondary mt-3" (click)="dismiss()">
            <span class="d-inline-block align-middle px-5">{{ (data?.dismissButton || translate.instant("pt.edp.edponline.common.cancel")) }}</span>
        </button>
        <button class="btn btn-primary ml-md-2 mt-3" *ngIf="data?.confirmButton" (click)="close()">
            <span class="d-inline-block align-middle px-5">{{ (data?.confirmButton || translate.instant("pt.edp.edponline.common.confirm")) }}</span>
        </button>
    </div>
</div>
